import { getProductBadgesRpc as getProductBadgesInAppRpc } from '../../../__generated__/chirp/com/hubspot/monetization/rpc/BadgeInAppService';
import { getProductBadgesRpc as getProductBadgesPublicRpc } from '../../../__generated__/chirp/com/hubspot/monetization/rpc/BadgePublicService';
import { logRavenException } from '../../errorUtils';
import { noAuthRpcClient, rpcClient } from '../../rpcClient';
export const fetchBadges = ({
  productApiNames,
  seatCount,
  isPublicUseCase
}) => {
  let badges = {
    productBadges: {}
  };
  let promiseError = undefined;

  // Free api names (e.g. "marketing-hub-free") are a concept supported
  // exclusively by the feature store service.
  const purchasableApiNames = productApiNames.filter(apiName => !apiName.includes('free'));
  const badgesPromise = isPublicUseCase ? noAuthRpcClient.call(getProductBadgesPublicRpc, {
    request: {
      productApiNames: purchasableApiNames,
      seatCount
    }
  }) : rpcClient.call(getProductBadgesInAppRpc, {
    request: {
      productApiNames: purchasableApiNames,
      seatCount
    }
  });
  return badgesPromise.then(response => {
    badges = response;
  }, error => {
    logRavenException({
      error,
      customMessage: error.message,
      additionalDetails: {
        productApiNames,
        seatCount
      }
    });
  }).catch(error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: 'fetchBadges: Promise successfully resolved but the catch block was triggered',
      additionalDetails: {
        productApiNames,
        seatCount
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return badges;
  });
};